

export const OEUserServiceResultType = {
    ok:                         'ok',
    networkError:               'networkError',
    badRequest:                 'badRequest',
    forbidden:                  'forbidden',
    rateLimitExceeded:          'rateLimitExceeded',
    internalServerError:        'internalServerError',
    unkownError:                'unkownError'
};

export class OEUserService {

    constructor(baseURL) {
        const defaultURL = process.env.isDevServer ? '/api' : 'https://api.effigos.com/api';

        this.baseURL = baseURL ? baseURL : defaultURL;
    }

    async registerUserInstitution(data) {

        try {

            let body = JSON.stringify(data);

            const response = await fetch(`${this.baseURL}/ic`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: body
            });

            //
            let resultType = OEUserServiceResultType.ok;

            if(!response.ok) {
                switch(response.status) {
                    case 400: resultType = OEUserServiceResultType.badRequest; break;
                    case 403: resultType = OEUserServiceResultType.forbidden; break;
                    case 429: resultType = OEUserServiceResultType.rateLimitExceeded; break;
                    case 500: resultType = OEUserServiceResultType.internalServerError; break;
                    default: resultType = OEUserServiceResultType.unkownError;
                }
            }

            let responseBody = await response.json();

            if(resultType === OEUserServiceResultType.ok && (responseBody.success == 'false' || responseBody.error))    {
                resultType = OEUserServiceResultType.unkownError;
            }

            return {
                result:     resultType,
                error:      responseBody.error || '',
                message:    responseBody.message || '',
            }

        } catch(error) {
            return {
                result:     OEUserServiceResultType.networkError,
                error:      '',
                message:    '',
            };
        }
    }
}

export default new OEUserService();